import { connect } from 'react-redux';
import { State } from 'store/types';

import { isEligible } from 'store/app/selector';
import View from './View';

const mapStateToProps = (state: State) => {
  const { auth, appReducer, remoteConfig } = state;
  return {
    email: auth.user.email,
    isSmartLockActive: remoteConfig?.configs?.configFlags?.isSmartLockActive,
    isAutoSignUp: isEligible(
      remoteConfig.configs?.AB?.autoFillSignUp,
      appReducer.run
    ),
    showChatNow: remoteConfig?.switches?.showChatNow,
    region: state.appReducer.region,
  };
};

export default connect(mapStateToProps)(View);
